import merge from "lodash/fp/merge";

export const DEFAULT_STATE = {};

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem("qa-state");
    if (serializedState === null) {
      return DEFAULT_STATE;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return DEFAULT_STATE;
  }
};

export const saveStateSlice = (slice) => {
  try {
    const serializedState = JSON.parse(localStorage.getItem("qa-state")) || {};

    for (let key in slice) {
      if (key === "segments") {
        serializedState[key] = slice[key];
      } else {
        serializedState[key] = merge(serializedState[key], slice[key]);
      }
    }

    const newState = merge({}, serializedState, slice);
    localStorage.setItem("qa-state", JSON.stringify(newState));
  } catch (err) {
    console.log(err);
  }
};

export const mergeStates = (preloadedState, persistedState = {}) => {
  try {
    delete preloadedState.local;
    if (
      preloadedState.transcription != null &&
      preloadedState.transcription.display_id !==
        persistedState.currently_transcribing_id
    ) {
      delete persistedState.segments;
      delete persistedState.currently_transcribing_id;
    } else {
      delete preloadedState.segments;
    }

    localStorage.setItem("qa-state", JSON.stringify(persistedState));
    return merge(preloadedState, persistedState);
  } catch (err) {
    console.log(err);
    return preloadedState;
  }
};
